import { mock, activityData } from '../../utils/mockdata';
// import { getUserProfile } from '@/store/modules/user';

var axios = require('axios');


export default {
    

    state: {
        activities: [],
        selectedActivity: {}
    }, 
    getters: {
        allActivities: (state) => state.activities,
        
        selectedActivity: (state) => state.selectedActivity
    },
    
    actions: {
        async fetchActivities({commit}) {
            console.log("fetch activities")

            await mock.onGet('/activities', { params: { accountid: '1' } }).reply(
                // function(config) {
                //     return [200, {data: activityData}]
                // }
               200, {data: activityData}
              );
              
            await axios.get('/activities', { params: { accountid: '1' } } )
            .then(resp => {
                commit('setActivities', resp.data.data),
                console.log("activities fetched. > " + resp.data.data.length)
            });
            
        },
        async updateActivity({commit}, activity) {
            commit('updateActivity', activity)
        },
        putSelectedActivity({commit}, activity) {
            commit('setSelectedActivity', activity)
        },
        addNewActivity({commit}, activity) {
            commit('addNewActivity', activity)
        }, 
        deleteActivity({commit}, activity) {
            commit('deleteActivity', activity)
        }
    },
    mutations: {
        setActivities: (state, activities) => (state.activities = activities),
        setSelectedActivity: (state, activity) => (state.selectedActivity = activity),
        updateActivity: (state, upditem) => {
            
            const index = state.activities.findIndex(item => item.id == upditem.id)
            if (index !== -1) {
                state.activities.splice(index, 1, upditem)
            }
            // console.log("... > "+ JSON.stringify(updactivity))
        },
        addNewActivity: (state, additem) => {
            //TODO save on server, id is set then
            let tmpitem = additem
            tmpitem.id = "mock_"+new Date().getTime()
            state.activities.unshift(additem)
        },
        deleteActivity: (state, delitem) => {
            const index = state.activities.findIndex(item => item.id == delitem.id)
            if (index !== -1) {
                state.activities.splice(index, 1)
            }
        }
    },
    
}

